<div class="padding">
	<b>Selected Styles:</b>

	<div class="flex column gap margin-top-small scrollable">
		@for (style of data.styles; track style.modelId) {
			<div>{{ style.brand.name }} - {{ style.code }} - {{ style.name }}</div>
		}
	</div>
</div>
